"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const RadioWrapper = styled_components_1.default.div `
  display: inline-block;
`;
const radioColor = ({ checked, disabled, theme }) => {
    if (checked && disabled) {
        return theme.neutral.main;
    }
    else if (checked && !disabled) {
        return theme.primary.main;
    }
    else {
        return theme.neutral.light;
    }
};
const StyledRadio = styled_components_1.default.span `
  display: inline-block;
  position: relative;
  border: 2px solid ${radioColor};
  width: ${({ width = "20px" }) => width};
  height: ${({ height = "20px" }) => height};
  left: 0;
  border-radius: 50%;
  margin-right: 6px;
  transition: all 0.3s;
  &::after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-radius: 50%;
    background-color: ${radioColor};
    opacity: 0;
    left: 50%;
    top: 50%;
    position: absolute;
    transform: scale(0);
    transition: all 110ms;
  }
`;
const ripple = (0, styled_components_1.keyframes) `
  0% {
    box-shadow: 0px 0px 0px 1px rgba(255, 147, 0, 0);
  } 
  50% { 
    box-shadow: 0px 0px 0px 6px rgba(255, 147, 0, 0.102);
  }
  100% {
    box-shadow: 0px 0px 0px 6px rgba(255, 147, 0, 0);
  }
`;
const StyledInput = styled_components_1.default.input `
  position: absolute;
  visibility: hidden;
  display: none;
  &:checked + ${StyledRadio} {
    animation: ${ripple} 0.3s linear forwards;
    &::after {
      width: 10px;
      height: 10px;
      opacity: 1;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      transform: scale(1);
    }
  }
  ${({ disabled }) => !disabled &&
    `
      &:checked {
        &:hover + ${StyledRadio} {
          background-color: #ff93001a;
        }
      }
      &:hover + ${StyledRadio} {
        background-color: #8080801a;
        box-shadow: 0px 0px 0px 6px #8080801a;
      }
    `}
`;
const StyledLabel = styled_components_1.default.label `
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 5px 0;
  margin-right: 15px;
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.text.primary};
  cursor: pointer;
  ${({ checked, disabled, theme }) => {
    if (checked) {
        return ` 
        font-weight: 500; 
        color: ${!disabled ? theme.primary.main : theme.text.secondary};
      `;
    }
    else if (disabled) {
        return `
        cursor: not-allowed;
        opacity: ${!checked ? 0.26 : 1};
    `;
    }
}}
`;
const RotaRadio = (0, react_1.forwardRef)((_a, ref) => {
    var { label, disabled = false, onChange, checked, width, height } = _a, props = __rest(_a, ["label", "disabled", "onChange", "checked", "width", "height"]);
    return (react_1.default.createElement(RadioWrapper, null,
        react_1.default.createElement(StyledLabel, { checked: checked, disabled: disabled },
            react_1.default.createElement(StyledInput, Object.assign({ ref: ref, type: "radio", checked: checked, onChange: onChange, disabled: disabled }, props)),
            react_1.default.createElement(StyledRadio, { checked: checked, disabled: disabled, width: width, height: height }),
            label)));
});
exports.default = RotaRadio;
